import { Component, input, output } from '@angular/core';
import { DateTime } from 'luxon';

import {
  NoRecordsComponent,
  SortIconComponent,
  ViewIconButtonComponent,
} from '@sandbox-platform/shared-ui';

import { CommissionInvoiceDTO } from '../../../../types/commission-invoice.types';
import { CommissionInvoiceStatusBadgeComponent } from './commission-invoice-status-badge.component';

@Component({
  standalone: true,
  imports: [
    NoRecordsComponent,
    SortIconComponent,
    ViewIconButtonComponent,
    CommissionInvoiceStatusBadgeComponent,
  ],
  selector: 'lib-commission-invoice-list-table',
  templateUrl: './commission-invoice-list-table.component.html',
})
export class CommissionInvoiceListTableComponent {
  invoices = input.required<CommissionInvoiceDTO[]>();
  canView = input<boolean>(false);
  sortBy = input<string>('created_at');
  sortDirection = input<'asc' | 'desc'>('desc');

  viewInvoice = output<CommissionInvoiceDTO>();
  sortChange = output<{ sortBy: string; sortDirection: 'asc' | 'desc' }>();

  protected onHeaderClick(field: string): void {
    const newDirection =
      this.sortBy() === field && this.sortDirection() === 'asc'
        ? 'desc'
        : 'asc';
    this.sortChange.emit({ sortBy: field, sortDirection: newDirection });
  }

  protected titleCase(value?: string): string {
    if (!value) return '-';
    return value
      .replace(/_/g, ' ')
      .replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1));
  }

  protected formatDate(date?: string | Date): string {
    if (!date) return '-';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(dateObj.getTime()) || dateObj.getFullYear() <= 1)
      return '-';
    return DateTime.fromJSDate(dateObj).toFormat('dd-MMM-yyyy');
  }

  protected formatDateTime(date?: string | Date): string {
    if (!date) return '-';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(dateObj.getTime()) || dateObj.getFullYear() <= 1)
      return '-';
    return DateTime.fromJSDate(dateObj).toFormat('dd-MMM-yyyy HH:mm');
  }

  protected formatMoney(amountMinor?: number, currency = 'KES'): string {
    if (amountMinor === undefined || amountMinor === null) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amountMinor / 100);
  }
}
